// extracted by mini-css-extract-plugin
export default {"container":"_purchase_container__TXIXU","wrapper":"_purchase_wrapper__3mQu-","card":"_purchase_card__X-QP+"};